<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="4" v-for="(v,k) in listGeneral.detalle" :key="k">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-img :src="v.foto" contain height="300px" max-height="300px" v-on="on">
                            </v-img>
                        </template>
                        <span>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td> <strong class="white--text body-2">Marca: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.marca"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Modelo: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.modelo"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Año: </strong> </td>
                                        <td class="body-2" v-html="v.anio"> </td>
                                    </tr>
                                    <tr>
                                        <td> <strong class="white--text body-2">Cédula: </strong>
                                        </td>
                                        <td class="body-2" v-html="v.numeroDocumento"> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </span>
                    </v-tooltip>
                    <div class="text-center">
                        <h3 class="headline"><strong>Placa:</strong> {{ v.placa }}</h3>
                        <h3 class="body-1 font-weight-bold"> {{ v.vigencia }}</h3>
                    </div>
                    <v-btn block rounded dark color="primary" @click="renovacion(v)">Realizar
                        Renovación</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformacionCertificadoComponent',
        inject:['updateData','next','recalcularPrima'],
        data: () => ({
            idCliente:null,
            listGeneral: {
                detalle: []
            },
            parametros: {},
            objForm: {
                objInfoSeguroActual: {},
                objInfoSeguroRenovacion: {},
                objFormFactura: {},
            }
        }),
        created(){
            var error = 'E';
            
            axios.post(`${BASE_URI}administrador/renovacion/vehiculo/cargaGeneral`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0 ) {  error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.updateData('listGeneral',this.listGeneral);
                        this.updateData('parametros',this.parametros);
                        this.idCliente = _.get(this.$root,['obUsuario','idCliente'],null);
                        return this.onLitarCertificado('L');
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        methods:{
            onLitarCertificado(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        'opcion': 'LISTAR_CERTIFICADO_RENOVAR',
                        'idCliente': this.idCliente
                    }

                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/certificado/listar`, objeto)
                        .then((r) => {
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0 ) {  error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                            this.listGeneral.detalle = r.data.data;
                        })
                        .catch((e) => {
                            mensajesAlerta(e,error);
                        });
                }
            },
            renovacion(objeto) {
                var error = 'E';
                var idCertificadoActual = _.get(this.objForm.objInfoSeguroActual,['dataCertificado','idCertificado'],0);

                if(parseInt(idCertificadoActual) != parseInt(objeto.idCertificado)){
                    this.objForm.objInfoSeguroActual = objeto;
                    
                    axios.post(`${BASE_URI}administrador/renovacion/vehiculo/listar-datos-renovar`,_.pick(objeto,['idCertificado','idPoliza']))
                         .then((r) => {
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0 ) {  error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.objForm.objInfoSeguroRenovacion = r.data.data.producto;
                                this.objForm.objInfoSeguroActual = _.omit(r.data.data,'producto');
                                this.objForm.objFormFactura = r.data.data.dataCertificado;
                                this.updateData('objForm.objInfoSeguroActual',this.objForm.objInfoSeguroActual);
                                this.updateData('objForm.objInfoSeguroRenovacion',this.objForm.objInfoSeguroRenovacion);
                                this.updateData('objForm.objFormFactura',this.objForm.objFormFactura);
                                
                                // Lista Coberturas
                                this.updateData('objForm.objInfoSeguroRenovacion.coberturas',this.mapListCobertura());
                                // Lista Beneficio Complementarios
                                this.updateData('objForm.objInfoSeguroRenovacion.servicios_incluidos',this.mapListbeneficioComplementario());
                                // Lista de Accesorios
                                this.updateData('objForm.objInfoSeguroRenovacion.accesorios',this.mapListAccesorio());

                                return this.recalcularPrima(false);
                         })
                         .then((r)=>{
                             if(!r) throw mensajeEstandar.errorPeticion;
                                this.next();
                         })
                         .catch((e) =>{
                             mensajesAlerta(e, error);
                         });
                }else
                    this.next();
            },
            mapListCobertura(){
                var lista               = _.get(this.objForm.objInfoSeguroRenovacion,'coberturas',[]);
                var listCoberturaActual = _.get(this.objForm.objInfoSeguroActual,'datosCoberturas',[]);
                var obSeguro            = _.get(this.objForm.objInfoSeguroRenovacion,['seguro','0'],{});
                var l                   = [];
                var idCobCasco          = this.parametros.id_cobertura_todo_riesgo_wizard;
                var listOrden           = [{'i':0,'id':idCobCasco},{'i':1,'id':6},{'i':2,'id':2}];

                l = _.map(lista,(v)=>{
                        v.index = _.uniqueId();
                        v.id_clasificacion_cobertura = parseInt(v.id_clasificacion_cobertura);
                        v.id_cobertura = parseInt(v.id_cobertura);
                        v.orden        = _.get(_.find(listOrden,{'id':parseInt(v.id_cobertura)}),'i',null);

                        var o = _.find(listCoberturaActual,{'id_cobertura':_.toString(v.id_cobertura)});
                        v.valor_cobertura_old = _.round(_.toNumber(_.get(o,'valor_cobertura',0)),0);

                        if(v.id_cobertura == idCobCasco && _.toNumber(_.get(v,'valor_recomendado',0)) == 0) {
                            v.valor_cobertura     = _.round(_.toNumber(_.get(obSeguro,'valor_recomendado',0)),0);
                            v.valor_cobertura_n   = _.round(_.toNumber(_.get(obSeguro,'valor_recomendado',0)),0);
                            v.valor_recomendado   = _.round(_.toNumber(_.get(obSeguro,'valor_recomendado',0)),0);
                            v.rango_inicial       = _.round(_.toNumber(_.get(obSeguro,'valor_recomendado_min',0)),0);
                            v.rango_final         = _.round(_.toNumber(_.get(obSeguro,'valor_recomendado_max',0)),0);
                            v.rango_intervalo     = _.round(_.toNumber(v.rango_intervalo),0);
                        }else{
                            v.valor_cobertura     = _.round(_.toNumber(v.valor_cobertura),0);
                            v.valor_cobertura_n   = _.round(_.toNumber(v.valor_cobertura),0);
                            v.valor_recomendado   = _.round(_.toNumber(v.valor_cobertura),0);
                            v.rango_inicial       = _.round(_.toNumber(v.rango_inicial),0);
                            v.rango_final         = _.round(_.toNumber(v.rango_final),0);
                            v.rango_intervalo     = _.round(_.toNumber(v.rango_intervalo),0);
                        }

                        return v;
                    });

                return l;
            },
            mapListbeneficioComplementario() {
                var l = [];
                var lista              = _.get(this.objForm.objInfoSeguroRenovacion,'servicios_incluidos',[]);
                var listBeneCompActual = _.get(this.objForm.objInfoSeguroActual,'datosBeneficiosComplementarios',[]);
                var o = _.find(_.get(this.objForm.objInfoSeguroRenovacion,'coberturas',[]),{'id_cobertura':this.parametros.id_cobertura_todo_riesgo_wizard});
                var valorVehiculo      = _.toNumber(_.get(o,'valor_cobertura',0));
                var mesesDiferidoPrima = _.toNumber(_.get(this.objForm.objInfoSeguroRenovacion,['seguro','0','mesesDiferidoPrima'],1));

                // Obtenemos los items de Beneficios que no cuenta el nuevo producto
                var listDiff = _.differenceBy(listBeneCompActual,lista,'id_beneficio_comp');                

                l = _.map(lista, (v) => {
                        v.index = _.uniqueId();
                        var o = _.find(listBeneCompActual, { 'id_beneficio_comp': v.id_beneficio_comp });
                        var s = _.split(v.base64,',');
                        v.base64 = _.includes(v.base64,'data:image/svg') ? `data:image/svg+xml;base64,${s[1]}` : v.base64;

                        if(_.isUndefined(v.active) || _.isNull(v.active))
                            v.active = !_.isUndefined(o) ? true : false;

                        v.mensaje = _.toNumber(v.valor_costo_diferido) > 0 ? `$${v.valor_costo_diferido}/MES` : 'GRATIS';
                    return v;
                });

                listDiff = _.map(_.cloneDeep(listDiff),(v)=>{
                                    v.index = _.uniqueId();
                                    var s = _.split(v.foto,',');
                                    v.base64 = _.includes(v.foto,'data:image/svg') ? `data:image/svg+xml;base64,${s[1]}` : v.foto;
                                    v.active = false;

                                    if(_.toNumber(v.id_tipo_calculo) == this.parametros.id_tipo_calculo_porc_beneficio_complementario)
                                        v.valor_costo_diferido = _.round(((valorVehiculo*_.toNumber(v.porc_costo))/100)/mesesDiferidoPrima,2);
                                    else
                                        v.valor_costo_diferido = v.valor_costo;

                                    v.mensaje = _.toNumber(v.valor_costo_diferido) > 0 ? `$${v.valor_costo_diferido}/MES` : 'GRATIS';
                                return v;
                            });
                            
                return _.unionBy(l,listDiff,'id_beneficio_comp');
            },
            mapListAccesorio() {
                var l = [];
                var lista = _.get(this.objForm.objInfoSeguroRenovacion,'accesorios',[]);
                var listAccesorioActual = _.get(this.objForm.objInfoSeguroActual,'datosInclusionAccesorios',[]);

                lista = _.map(_.cloneDeep(lista),(v)=>{ v.idAccesorio = _.toNumber(v.id_accesorio); return v; });
                var listDiff = _.differenceBy(listAccesorioActual,lista,'idAccesorio')
                
                l        = this.mapList(listAccesorioActual,lista);
                listDiff = this.mapList(listDiff,listDiff);
                
                return _.unionBy(l,listDiff,'idAccesorio');
            },
            mapList(listActual,listNueva){
                var keys = [ {id:2,orden:0},{id:4,orden:1},{id:3,orden:2},{id:5,orden:3} ];
                var l = [];
                l = _.map(listNueva, (v) => {
                        v.id_accesorio = parseInt(v.id_accesorio);
                        if (_.isUndefined(v.index)) {
                            var o = _.find(listActual, { 'idAccesorio': v.id_accesorio });

                            v.index                = _.uniqueId();
                            v.orden                = _.get(_.find(keys,{'id':v.id_accesorio}),'orden',null);
                            v.marca                = _.get(o, 'marca', null);
                            v.modelo               = _.get(o, 'modelo', null);
                            v.perfil               = _.get(o, 'perfil', null);
                            v.anchura              = _.get(o, 'anchura', null);
                            v.cantidad             = _.get(o, 'cantidad', null);
                            v.descripcion          = _.get(o, 'descripcion', null);
                            v.rin                  = _.get(o, 'rin', null);
                            v.idInclusion          = _.get(o, 'idInclusion', null);
                            v.name_factura         = _.isUndefined(_.get(o, 'rutaAccesorio', undefined)) ? null : 'accesorio.png';
                            v.name_foto            = _.isUndefined(_.get(o, 'rutaFactura', undefined)) ? null : 'factura.png';
                            v.idInclusionAccesorio = _.get(o, 'idInclusionAccesorio', null);
                            v.valorAsegurado       = parseFloat(_.get(o, 'valorAsegurado', 0));
                            v.icono                = `data:image/svg+xml;base64,${v.icono}`;
                            v.add                  = !_.isUndefined(o) ? true : false;
                        }
                        return v;
                    });    
                
                return l;
            }
        },
    }
</script>
